import jQuery from 'jquery'
import settings from '../utils/settings';

(function ($) {
  const methods = {
    defaultOptions: {
      hideAfterTime: null,
      transitionSpeed: settings.TRANSITION_SPEED,
      mode: 'menu', // menu/select/switch
      togglerSelector: '.js-toggler',
      collapseSelector: '.js-collapse-toggler',
      menuSelector: '.js-dropdown',
      itemSelector: '.js-dropdown-item',
      openedClass: 'b-dropdown__item_opened',
      disabledClass: 'disabled',
      placeholderClass: 'b-dropdown__item_placeholder',
      onItemClick: null
    },

    init: function (customOptions) {
      
      return this.each(function () {
        this.timeout = null
        this.options = {}
        $.extend(this.options, methods.defaultOptions, customOptions)

        const self = this
        const $dropdown = $(this)
        const $toggler = $dropdown.find(this.options.togglerSelector)
        const $collapse = $dropdown.find(this.options.collapseSelector)
        const $menu = $dropdown.find(this.options.menuSelector)
        const $item = $menu.find(this.options.itemSelector)

        $toggler.click(function (e) {
          e.preventDefault()

          if ($dropdown.hasClass(self.options.disabledClass)) {
            return
          }

          if ($(this).hasClass(self.options.openedClass)) {
            methods.collapse.apply($dropdown)
          } else {
            methods.expand.apply($dropdown)
          }
        })

        $dropdown
          .on('mouseleave', () => {
            this.timeout = setTimeout(() => {
              methods.collapse.apply($dropdown)
            }, this.options.hideAfterTime || this.options.transitionSpeed)
          })
          .on('mouseenter', () => {
            clearTimeout(this.timeout)
          })

        $collapse.click(function (e) {
          e.preventDefault()

          const $link = $(this)

          $link.toggleClass('active')
          $($link.attr('href')).slideToggle(self.options.transitionSpeed)
        })

        $item.click(function (e) {
          if (self.options.mode !== 'menu') {
            e.preventDefault()
          }

          if (self.options.mode === 'switch') {
            $(this).addClass('b-dropdown__item_regular')
            $item.filter('.b-dropdown__item_inner').not($(this)).removeClass('b-dropdown__item_regular')
            
            $toggler.text($(this).text()).removeClass(self.options.placeholderClass)
            $toggler.attr('data-value', $(this).attr('data-value'))
            methods.collapse.apply($dropdown)
          }

          if (typeof self.options.onItemClick === 'function') {
            self.options.onItemClick.apply($(this), [e])
          }
        })
      })
    },

    expand: function () {
      return this.each(function () {
        const $toggler = $(this).find(this.options.togglerSelector)
        const $menu = $(this).find(this.options.menuSelector)

        $toggler.addClass(this.options.openedClass)
        $menu.stop(true, true).fadeIn(this.options.transitionSpeed)
      })
    },

    collapse: function () {
      return this.each(function () {
        const $toggler = $(this).find(this.options.togglerSelector)
        const $menu = $(this).find(this.options.menuSelector)

        $toggler.removeClass(this.options.openedClass)
        $menu.stop(true, true).fadeOut(this.options.transitionSpeed)
      })
    },

    setItemHandler: function (callback) {
      return this.each(function () {
        this.options.onItemClick = callback
      })
    }
  }

  $.fn.dropdown = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1))
    } else if (typeof method === 'object' || !method) {
      return methods.init.apply(this, arguments)
    } else {
      $.error('Unknown method: ' + method)
    }
  }
})(jQuery)
